export default function contactGroupReducer(contact, action) {
  switch (action.type) {
    case "set":
      return action.value;

    case "deleteContact":
      return { ...contact, id: undefined, deleted: true };
    case "restoreContact":
      return { ...contact, id: action.id, deleted: false };

    default:
      return { ...contact, [action.type]: action.value };
  }
}
